import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";
@Injectable({ providedIn: 'root' })

export class DashboardService {
    backendUrl: string = environment.apiUrl;
    url_final: string;

    constructor(private http: HttpClient) {
    }

    consultarEnviosTotales(seller_id, filtro){
        this.url_final = this.backendUrl + "/rmsfe/get_envios_totales_api?seller_id="
        this.url_final = `${this.url_final}${seller_id}&filtro=${filtro}`;
        return this.http.get<any>(this.url_final,  {observe: 'response'})
        .pipe(map(response => {
            return response;
        }));
    }
    
    consultarEnviosEstatus(seller_id, filtro){
        this.url_final = this.backendUrl + "/rmsfe/get_envios_estatus_api?seller_id="
        this.url_final = `${this.url_final}${seller_id}&filtro=${filtro}`;
        return this.http.get<any>(this.url_final,  {observe: 'response'})
        .pipe(map(response => {
            return response;
        }));
    }

    consultarEnviosEstatusPorcentaje(seller_id, filtro){
        this.url_final = this.backendUrl + "/rmsfe/get_envios_estatus_porcentaje_api?seller_id="
        this.url_final = `${this.url_final}${seller_id}&filtro=${filtro}`;
        return this.http.get<any>(this.url_final,  {observe: 'response'})
        .pipe(map(response => {
            return response;
        }));
    }

    consultarGraficasSeller(seller_id){
        this.url_final = this.backendUrl + "/rmsfe/get_graficas_seller_api?seller_id="
        this.url_final = `${this.url_final}${seller_id}`;
        return this.http.get<any>(this.url_final,  {observe: 'response'})
        .pipe(map(response => {
            return response;
        }));
    }

    guardarConfiguracionSeller(data, seller_id,tipo_accion){
        this.url_final = this.backendUrl + "/rmsfe/guarda_edita_elimina_configuracion_seller_api"
        this.url_final = `${this.url_final}`;
        return this.http.post<any>(this.url_final, { data, seller_id, tipo_accion})
        .pipe(map(response => {
            return response;
        }));
    }

    validaConfiguracionSeller(data, seller_id){
        this.url_final = this.backendUrl + "/rmsfe/valida_configuracion_api"
        this.url_final = `${this.url_final}`;
        return this.http.post<any>(this.url_final, { data, seller_id})
        .pipe(map(response => {
            return response;
        }));
    }

    guardarOrdenGraficas(grafica_anterior, grafica_actual){
        this.url_final = this.backendUrl + "/rmsfe/guardar_orden_graficas_api"
        this.url_final = `${this.url_final}`;
        return this.http.post<any>(this.url_final, { grafica_anterior, grafica_actual})
        .pipe(map(response => {
            return response;
        }));
    }

    consultarEntradasEstatus(seller_id, filtro){
        this.url_final = this.backendUrl + "/rmsfe/get_envios_entradas_api?seller_id="
        this.url_final = `${this.url_final}${seller_id}&filtro=${filtro}`;
        return this.http.get<any>(this.url_final,  {observe: 'response'})
        .pipe(map(response => {
            return response;
        }));
    }

    consultarDevolucionesEstatus(seller_id, filtro){
        this.url_final = this.backendUrl + "/rmsfe/get_envios_devoluciones_api?seller_id="
        this.url_final = `${this.url_final}${seller_id}&filtro=${filtro}`;
        return this.http.get<any>(this.url_final,  {observe: 'response'})
        .pipe(map(response => {
            return response;
        }));
    }

    consultarTicketsEstatus(seller_id, filtro){
        this.url_final = this.backendUrl + "/rmsfe/get_tickets_api?seller_id="
        this.url_final = `${this.url_final}${seller_id}&filtro=${filtro}`;
        return this.http.get<any>(this.url_final,  {observe: 'response'})
        .pipe(map(response => {
            return response;
        }));
    }

    consultarTicketsMotivo(seller_id, filtro){
        this.url_final = this.backendUrl + "/rmsfe/get_motivos_tickets_api?seller_id="
        this.url_final = `${this.url_final}${seller_id}&filtro=${filtro}`;
        return this.http.get<any>(this.url_final,  {observe: 'response'})
        .pipe(map(response => {
            return response;
        }));
    }

    consultarDatosGraficaEstatusEnvio(seller_id, filtro){
        this.url_final = this.backendUrl + "/rmsfe/get_estatus_envios_api?seller_id="
        this.url_final = `${this.url_final}${seller_id}&filtro=${filtro}`;
        return this.http.get<any>(this.url_final,  {observe: 'response'})
        .pipe(map(response => {
            return response;
        }));
    }

    ml_refresh_token_expiration(seller_id) {
        this.url_final = this.backendUrl + "/rmsfe/ml_refresh_token_expiration?seller_id="
        this.url_final = `${this.url_final}${seller_id}`;
        return this.http.get<any>(this.url_final,  {observe: 'response'})
        .pipe(map(response => {
            return response;
        }));
    }

    tik_tok_refresh_token_expiration(seller_id) {
        this.url_final = this.backendUrl + "/rmsfe/tik_tok_refresh_token_expiration?seller_id="
        this.url_final = `${this.url_final}${seller_id}`;
        return this.http.get<any>(this.url_final,  {observe: 'response'})
        .pipe(map(response => {
            return response;
        }));
    }
}